import PropTypes from 'prop-types'
import QuoteIcon from './quote-icon'
import {
 PullquoteRoot, Quote, Attribution,
} from './pullquote.styles'

const Pullquote = (props) => {
  const { attribution, text, hideQuote = false } = props
  return (
    <PullquoteRoot>
      {!hideQuote && <QuoteIcon viewBox='0 0 36 36' style={{ width: '36px', height: '36px' }} />}
      <Quote variant="h4">
        {text}
      </Quote>
      {attribution && <Attribution> {attribution}</Attribution>}
    </PullquoteRoot>
  )
}

Pullquote.propTypes = {
  attribution: PropTypes.string,
  text: PropTypes.string,
  hideQuote: PropTypes.bool,
}

export default Pullquote
